module.exports = __webpack_public_path__ + "img/girl_black_earrings.562725b1.png";